module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, assetableAttributes, formatter;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='avatar-presenter list-item'>\n  <div class='avatar-wrapper'>\n    <span class='icon icon-file'></span>\n  </div>\n  <div class='presenter-wrapper'>\n    <a class='blank file-name' href='" + ($e($c(this.asset.get('url')))) + "' target='_blank'>");
      $o.push("      " + $e($c(this.asset.get('title'))));
      $o.push("    </a>\n    <span class='icon icon-x' href='javascript:;' data-behavior='confirm-delete'></span>\n    <input class='hidden js-asset-image-attached' type='checkbox' name='js-asset-image-attached' checked='" + ($e($c(this.attachedFileIsImage))) + "' value data-parsley-mincheck='1' data-parsley-error-message='Bring your pitch to life by adding some images.'>\n    <div class='delete-replace file-size subtext'>");
      formatter = new this.FormattedNumber(this.asset.get('filesize'));
      $o.push("      <div class='js-file-metadata'>" + ($e($c(formatter.friendlyFileSize()))) + "</div>\n    </div>\n    <div class='delete-confirmation'>\n      Are you sure?\n      <a class='js-cancel-delete pipe-separated' href='javascript:;' data-behavior='cancel-delete'>Cancel</a>\n      <a class='js-remove-asset pipe-separated' href='javascript:;'>Delete</a>");
      if (!this.asset.get("assetting_id")) {
        assetableAttributes = (this.assetable_type.toLowerCase()) + "[assettings_attributes][]";
        $o.push("      <input name='" + ($e($c(assetableAttributes))) + "[asset_type]' value='requirement'>\n      <input name='" + ($e($c(assetableAttributes))) + "[asset_id]' value='" + ($e($c(this.asset.get('asset_id')))) + "' type='hidden'>");
      }
      $o.push("    </div>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/platform/templates/assets/requirement_assetting_form.js.hamlc
// module id = 1557
// module chunks = 17